import { render, staticRenderFns } from "./ReceiptPdf.vue?vue&type=template&id=72e5c4e0&"
import script from "./ReceiptPdf.vue?vue&type=script&lang=js&"
export * from "./ReceiptPdf.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptPdf.vue?vue&type=style&index=0&id=72e5c4e0&prod&lang=scss&"
import style1 from "./ReceiptPdf.vue?vue&type=style&index=1&id=72e5c4e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports